/**
 * Discourage saving images via right-click or drag.
 * Uses event delegation so dynamically loaded images are covered too.
 */
(function () {
  function getImageFromTarget(target) {
    if (!(target instanceof Element)) {
      return null;
    }

    return target instanceof HTMLImageElement ? target : target.closest("img");
  }

  document.addEventListener(
    "contextmenu",
    (event) => {
      if (getImageFromTarget(event.target)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    "dragstart",
    (event) => {
      if (getImageFromTarget(event.target)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );
})();
